import { Link } from '~/components'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { SiteFooterColumn } from './SiteFooterColumn'
import styles from './SiteFooterLinkColumn.module.scss'
import { SiteFooterLinkColumnProps } from './SiteFooterLinkColumn.types'

export const SiteFooterLinkColumn = ({
  category,
  index,
  isMobile,
}: SiteFooterLinkColumnProps) => {
  return (
    <SiteFooterColumn
      title={category.categoryTitle}
      panelId={`site-footer-links-${index}`}
      isMobile={isMobile}>
      {category.links.map((link, linkIndex) => {
        return (
          <Link
            key={linkIndex}
            href={link.href}
            target={link.openInNewWindow ? '_blank' : '_self'}
            className={styles.link}>
            <Typography
              tag={TypographyTag.span}
              variant={TypographyVariant.BodyRegular}
              className={styles.linkText}>
              {link.title}
            </Typography>
          </Link>
        )
      })}
    </SiteFooterColumn>
  )
}
